import React from 'react';
import { connect, type ConnectedProps } from 'react-redux';
import { useTheme } from '@mui/system';
import { useMediaQuery } from '@mui/material';

import { getPriceGuideCopy } from '@/utils/get-relevant-price-for-vehicle';
import { H5 } from '@/components/type';

import {
  CarImage,
  CarImageWrapper,
  ModelDetails,
  ModelYear,
  RecommendedFeaturesSmall,
  RecommendedFeaturesContainer,
  Price,
  TitleDivider,
  AddVehicleButton,
} from './styles';
import { type Dispatch } from '@/app-state/store';
import { type VehicleSearchResult } from '@tac/vehicle-api-client/types';
import { generateRedbookImageUrl } from '@/utils/get-redbook-image';

const mapDispatch = (dispatch: Dispatch) => ({
  addToCompare: dispatch.compare.addToCompare,
});

const connector = connect(null, mapDispatch);

type MinicartListingProps = ConnectedProps<typeof connector> & {
  vehicle: VehicleSearchResult;
  column: number;
};

// @ts-expect-error [PLEASE FIX]: Property 'addToCompare' does not exist on type '{ vehicle: VehicleSearchResult; column: number; }'.
export const MinicartListingComponent = ({ vehicle, addToCompare, column }: MinicartListingProps) => {
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));

  const {
    vehicleid: redbookCode,
    makedescription: make,
    modeldescription: model,
    year,
    minprice,
    maxprice,
    photoId,
    safetyfeatures,
  } = vehicle;

  const image = generateRedbookImageUrl(photoId ?? undefined);

  const handleAddVehicleButton = () => {
    addToCompare(redbookCode);
  };

  const recommendedFeaturesLabel = smUp ? 'Recommended features' : "Rec'd features";

  return (
    <>
      <CarImageWrapper column={column}>
        <CarImage src={image} alt={`${year} ${make} ${model}`} />
      </CarImageWrapper>
      <ModelDetails column={column}>
        <H5>
          {make} {model}
        </H5>
        <ModelYear>{year}</ModelYear>
      </ModelDetails>
      <TitleDivider column={column} />
      <Price column={column}>
        {getPriceGuideCopy({
          privateMinPrice: minprice,
          privateMaxPrice: maxprice,
          newPrice: minprice == maxprice ? maxprice : undefined,
        })}
      </Price>
      <RecommendedFeaturesContainer column={column}>
        <RecommendedFeaturesSmall>{recommendedFeaturesLabel}</RecommendedFeaturesSmall>
        <RecommendedFeaturesSmall>
          <strong>
            {safetyfeatures?.length}/{10}
          </strong>
        </RecommendedFeaturesSmall>
      </RecommendedFeaturesContainer>
      <AddVehicleButton
        eventText="Add vehicle"
        fullWidth
        onClick={handleAddVehicleButton}
        aria-label={`Add ${year} ${make} ${model} to comparison`}
        column={column}
      >
        Add vehicle
      </AddVehicleButton>
    </>
  );
};

export const MinicartListing = connector(MinicartListingComponent);
